import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftOutlook = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 11.3569,
				y: 5.3103,
				width: 30.4429,
				height: 35.0302,
				fill: "url(#pattern0_2088_9096)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .2,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M39.801 21.2786V35.2664C39.801 35.7272 39.618 36.1692 39.2921 36.495C38.9662 36.8209 38.5243 37.004 38.0634 37.004H15.0749C14.614 37.004 14.1721 36.8209 13.8462 36.495C13.5203 36.1692 13.3373 35.7272 13.3373 35.2664V21.2786C13.3331 21.4111 13.3668 21.542 13.4345 21.6559C13.5023 21.7698 13.6012 21.862 13.7195 21.9215L15.266 22.7903V7.15186C15.2567 6.94873 15.2875 6.74575 15.3567 6.55454C15.4259 6.36333 15.5321 6.18765 15.6693 6.03755C15.8065 5.88745 15.972 5.76588 16.1562 5.6798C16.3404 5.59372 16.5398 5.54481 16.743 5.53589H36.3779C36.7852 5.55836 37.167 5.74078 37.4404 6.04343C37.7137 6.34609 37.8565 6.74447 37.8375 7.15186V22.7903L39.4014 21.9215C39.5204 21.8612 39.6206 21.7693 39.6911 21.6559C39.7615 21.5426 39.7996 21.4121 39.801 21.2786Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .12,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 12.3823,
				y: 5.08447,
				width: 28.3578,
				height: 32.945,
				fill: "url(#pattern1_2088_9096)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .12,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M39.8015 21.2789V35.2666C39.8015 35.7274 39.6184 36.1694 39.2926 36.4953C38.9667 36.8211 38.5248 37.0042 38.0639 37.0042H15.0754C14.6145 37.0042 14.1725 36.8211 13.8467 36.4953C13.5208 36.1694 13.3378 35.7274 13.3378 35.2666V21.2789C13.3335 21.4113 13.3673 21.5422 13.435 21.6561C13.5028 21.77 13.6016 21.8622 13.72 21.9218L15.2665 22.7906V7.15211C15.2572 6.94897 15.288 6.74599 15.3572 6.55479C15.4264 6.36358 15.5326 6.18789 15.6698 6.03779C15.807 5.88769 15.9725 5.76612 16.1567 5.68004C16.3409 5.59396 16.5403 5.54506 16.7435 5.53613H36.3784C36.7856 5.5586 37.1675 5.74102 37.4409 6.04368C37.7142 6.34633 37.857 6.74472 37.838 7.15211V22.7906L39.4019 21.9218C39.5209 21.8614 39.6211 21.7695 39.6916 21.6562C39.762 21.5428 39.8001 21.4123 39.8015 21.2789Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.8025 21.279C39.8026 21.1494 39.7691 21.022 39.7051 20.9093C39.6411 20.7965 39.549 20.7024 39.4376 20.6361L28.4733 13.6857L28.369 13.6162C28.138 13.5077 27.8858 13.4514 27.6305 13.4514C27.3753 13.4514 27.1231 13.5077 26.8921 13.6162L26.7357 13.7204L14.7983 20.6708C14.6845 20.7344 14.5903 20.8279 14.5259 20.9413C14.4616 21.0546 14.4296 21.1835 14.4334 21.3138C14.4337 21.4477 14.4692 21.5791 14.5363 21.695C14.6034 21.8109 14.6997 21.9071 14.8157 21.974L26.753 28.9245L26.9094 29.0287C27.1405 29.1372 27.3926 29.1935 27.6479 29.1935C27.9032 29.1935 28.1553 29.1372 28.3864 29.0287L28.5428 28.9245L39.5071 21.974C39.6123 21.8937 39.6948 21.7874 39.7466 21.6655C39.7984 21.5437 39.8176 21.4105 39.8025 21.279Z",
			fill: "#123B6D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1555 17.3691H15.3188V24.5455H23.1555V17.3691Z",
			fill: "#0364B8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8379 10.5057V7.23902C37.8569 6.83163 37.7141 6.43324 37.4408 6.13059C37.1674 5.82794 36.7855 5.64552 36.3783 5.62305H16.7955C16.5923 5.63197 16.3929 5.68088 16.2087 5.76696C16.0245 5.85304 15.859 5.97461 15.7219 6.12471C15.5847 6.27481 15.4784 6.45049 15.4092 6.6417C15.34 6.83291 15.3092 7.03589 15.3185 7.23902V10.5057H37.8379Z",
			fill: "#0358A7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1555 10.5056H15.3188V17.3518H23.1555V10.5056Z",
			fill: "#0078D4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9924 10.5056H23.1558V17.3518H30.9924V10.5056Z",
			fill: "#28A8EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8384 10.5056H30.9922V17.3518H37.8384V10.5056Z",
			fill: "#50D9FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8384 17.3691H30.9922V24.5455H37.8384V17.3691Z",
			fill: "#28A8EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9924 17.3691H23.1558V24.5455H30.9924V17.3691Z",
			fill: "#0078D4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9924 24.5457H23.1558V31.722H30.9924V24.5457Z",
			fill: "#0364B8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1555 24.5457H15.3188V31.0791H23.1555V24.5457Z",
			fill: "#14447D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8384 24.5457H30.9922V31.722H37.8384V24.5457Z",
			fill: "#0078D4"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .35,
			children: /* @__PURE__ */ _jsx("g", {
				style: { mixBlendMode: "multiply" },
				opacity: .35,
				children: /* @__PURE__ */ _jsx("g", {
					opacity: .35,
					style: { mixBlendMode: "multiply" },
					children: /* @__PURE__ */ _jsx("path", {
						d: "M39.4201 21.9217L28.0213 28.8722L27.8476 28.9764C27.6119 29.0903 27.3535 29.1494 27.0917 29.1494C26.83 29.1494 26.5716 29.0903 26.3359 28.9764L26.1621 28.8722L13.7903 21.9217C13.672 21.8622 13.5731 21.77 13.5053 21.6561C13.4376 21.5422 13.4039 21.4113 13.4081 21.2788V35.2665C13.4081 35.7274 13.5911 36.1694 13.917 36.4952C14.2429 36.8211 14.6848 37.0042 15.1457 37.0042H38.0821C38.5429 37.0042 38.9849 36.8211 39.3108 36.4952C39.6366 36.1694 39.8197 35.7274 39.8197 35.2665V21.2788C39.8182 21.4123 39.7802 21.5428 39.7098 21.6561C39.6393 21.7695 39.5391 21.8614 39.4201 21.9217Z",
						fill: "white"
					})
				})
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .06,
			children: /* @__PURE__ */ _jsxs("g", {
				style: { mixBlendMode: "multiply" },
				opacity: .06,
				children: [/* @__PURE__ */ _jsx("rect", {
					x: 12.3833,
					y: 20.0972,
					width: 28.3578,
					height: 17.5151,
					fill: "url(#pattern2_2088_9096)"
				}), /* @__PURE__ */ _jsx("g", {
					opacity: .06,
					style: { mixBlendMode: "multiply" },
					children: /* @__PURE__ */ _jsx("path", {
						d: "M39.4205 21.9217L28.0218 28.8722L27.8481 28.9764C27.6124 29.0903 27.354 29.1494 27.0922 29.1494C26.8304 29.1494 26.5721 29.0903 26.3364 28.9764L26.1626 28.8722L13.7908 21.9217C13.6724 21.8622 13.5736 21.77 13.5058 21.6561C13.4381 21.5422 13.4043 21.4113 13.4086 21.2788V35.2665C13.4086 35.7274 13.5916 36.1694 13.9175 36.4952C14.2433 36.8211 14.6853 37.0042 15.1462 37.0042H38.0826C38.5434 37.0042 38.9854 36.8211 39.3113 36.4952C39.6371 36.1694 39.8202 35.7274 39.8202 35.2665V21.2788C39.8187 21.4123 39.7807 21.5428 39.7102 21.6561C39.6398 21.7695 39.5396 21.8614 39.4205 21.9217Z",
						fill: "white"
					})
				})]
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.4196 21.9217L28.0209 28.8722L27.8471 28.9764C27.6114 29.0903 27.353 29.1494 27.0912 29.1494C26.8295 29.1494 26.5711 29.0903 26.3354 28.9764L26.1616 28.8722L13.7898 21.9217C13.6715 21.8622 13.5726 21.77 13.5049 21.6561C13.4371 21.5422 13.4034 21.4113 13.4076 21.2788V35.2665C13.4076 35.7274 13.5906 36.1694 13.9165 36.4952C14.2424 36.8211 14.6843 37.0042 15.1452 37.0042H38.0816C38.5424 37.0042 38.9844 36.8211 39.3103 36.4952C39.6361 36.1694 39.8192 35.7274 39.8192 35.2665V21.2788C39.8178 21.4123 39.7797 21.5428 39.7093 21.6561C39.6388 21.7695 39.5386 21.8614 39.4196 21.9217Z",
			fill: "url(#paint0_linear_2088_9096)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0585 36.9173H38.1166C38.4728 36.9114 38.8185 36.7961 39.107 36.5871L26.1792 28.6984L26.0055 28.5941L13.8422 21.4873L13.373 21.2788V35.1797C13.3728 35.6316 13.5487 36.0659 13.8634 36.3903C14.1781 36.7147 14.6068 36.9037 15.0585 36.9173Z",
			fill: "url(#paint1_linear_2088_9096)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .48,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 2.2002,
				y: 10.332,
				width: 24.6045,
				height: 24.6045,
				fill: "url(#pattern3_2088_9096)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .48,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M21.679 12.4692H7.01359C6.19788 12.4692 5.53662 13.1305 5.53662 13.9462V28.6116C5.53662 29.4273 6.19788 30.0886 7.01359 30.0886H21.679C22.4947 30.0886 23.156 29.4273 23.156 28.6116V13.9462C23.156 13.1305 22.4947 12.4692 21.679 12.4692Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .24,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 5.08447,
				y: 11.9653,
				width: 18.7662,
				height: 18.7662,
				fill: "url(#pattern4_2088_9096)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .24,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M21.679 12.4692H7.01359C6.19788 12.4692 5.53662 13.1305 5.53662 13.9462V28.6116C5.53662 29.4273 6.19788 30.0886 7.01359 30.0886H21.679C22.4947 30.0886 23.156 29.4273 23.156 28.6116V13.9462C23.156 13.1305 22.4947 12.4692 21.679 12.4692Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .75,
			d: "M39.8021 21.2789C39.8023 21.1493 39.7687 21.0219 39.7048 20.9091C39.6408 20.7964 39.5486 20.7023 39.4372 20.636L37.856 19.7324V7.23902C37.875 6.83163 37.7322 6.43324 37.4588 6.13059C37.1855 5.82794 36.8036 5.64552 36.3964 5.62305H16.7962C16.593 5.63197 16.3936 5.68088 16.2094 5.76696C16.0252 5.85304 15.8597 5.97461 15.7226 6.12471C15.5854 6.27481 15.4791 6.45049 15.4099 6.6417C15.3407 6.83291 15.3099 7.03589 15.3192 7.23902V22.8775L13.7728 22.0087C13.6544 21.9491 13.5555 21.8569 13.4878 21.743C13.42 21.6291 13.3863 21.4982 13.3905 21.3658V35.3535C13.3905 35.8144 13.5736 36.2563 13.8994 36.5822C14.2253 36.9081 14.6673 37.0911 15.1281 37.0911H38.0819C38.5427 37.0911 38.9847 36.9081 39.3106 36.5822C39.6364 36.2563 39.8195 35.8144 39.8195 35.3535V21.2789H39.8021Z",
			fill: "url(#paint2_linear_2088_9096)",
			style: { mixBlendMode: "soft-light" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6785 12.4692H7.0131C6.19739 12.4692 5.53613 13.1305 5.53613 13.9462V28.6116C5.53613 29.4273 6.19739 30.0886 7.0131 30.0886H21.6785C22.4942 30.0886 23.1555 29.4273 23.1555 28.6116V13.9462C23.1555 13.1305 22.4942 12.4692 21.6785 12.4692Z",
			fill: "#0F78D4"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "soft-light" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M21.6785 12.4692H7.0131C6.19739 12.4692 5.53613 13.1305 5.53613 13.9462V28.6116C5.53613 29.4273 6.19739 30.0886 7.0131 30.0886H21.6785C22.4942 30.0886 23.1555 29.4273 23.1555 28.6116V13.9462C23.1555 13.1305 22.4942 12.4692 21.6785 12.4692Z",
				fill: "url(#paint3_linear_2088_9096)",
				style: { mixBlendMode: "soft-light" }
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.367 18.8639C10.6979 18.1381 11.2438 17.5315 11.9308 17.1263C12.7005 16.6826 13.58 16.4657 14.4677 16.5007C15.2768 16.4896 16.0743 16.6935 16.7787 17.0915C17.4457 17.5058 17.9725 18.1113 18.2905 18.8291C18.664 19.5845 18.8488 20.4193 18.8291 21.2618C18.8501 22.1379 18.6656 23.0067 18.2905 23.7987C17.9337 24.5126 17.3865 25.114 16.7092 25.5363C15.9851 25.9501 15.1626 26.1602 14.3287 26.1444C13.5003 26.1605 12.6833 25.9503 11.9656 25.5363C11.3037 25.1441 10.7673 24.5715 10.4191 23.8856C10.0483 23.1354 9.86352 22.3069 9.88043 21.4703C9.83144 20.575 9.9983 19.6811 10.367 18.8639ZM12.1046 22.9299C12.2777 23.3831 12.5797 23.7757 12.9734 24.0593C13.381 24.3418 13.8677 24.4878 14.3635 24.4763C14.8822 24.4978 15.394 24.3516 15.8231 24.0593C16.2152 23.7668 16.5164 23.3692 16.6919 22.9125C16.8711 22.3989 16.9593 21.8579 16.9525 21.3139C16.9551 20.7716 16.873 20.2323 16.7092 19.7153C16.5518 19.2489 16.262 18.8383 15.8752 18.5337C15.4573 18.2155 14.9402 18.0555 14.4156 18.0819C13.9144 18.0704 13.4221 18.2162 13.0081 18.499C12.6032 18.7866 12.2895 19.1848 12.1046 19.6458C11.6874 20.7007 11.6874 21.8749 12.1046 22.9299Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern0_2088_9096",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image0_2088_9096",
					transform: "scale(0.0135135 0.0117647)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern1_2088_9096",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image1_2088_9096",
					transform: "scale(0.0144928 0.0125)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern2_2088_9096",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image2_2088_9096",
					transform: "scale(0.0144928 0.0232558)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern3_2088_9096",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image3_2088_9096",
					transform: "scale(0.0166667)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern4_2088_9096",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image4_2088_9096",
					transform: "scale(0.0217391)"
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2088_9096",
				x1: 35.6316,
				y1: 17.7862,
				x2: 17.4562,
				y2: 39.4542,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#35B8F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: .9,
					stopColor: "#0F78D1"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2088_9096",
				x1: 26.2313,
				y1: 21.2788,
				x2: 26.2313,
				y2: 36.9347,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#35B8F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#28A8EA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2088_9096",
				x1: 16.5529,
				y1: 5.55354,
				x2: 35.6492,
				y2: 38.6202,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: .7
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2088_9096",
				x1: 8.59432,
				y1: 11.3224,
				x2: 20.0973,
				y2: 31.2354,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: .7
				})]
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image0_2088_9096",
				width: 74,
				height: 85,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABVCAYAAADuUHI/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAD5UlEQVR4Xu2d3W7bRhBGz8qyZMWp46aN3BYtChRJkbxA3v8xivYmQd2foH9WXSSS4nB78e2YtCyTkwK94GYOIAgmaRhzPLsk4E/jlHPGS0opDV0zFvL7FA4kz/VF0AQ4KO9jFpaBBngHNF5hvaKKoAQcAkfAApgjYWOUlZGgDfAGWANvUYP1Cpv2nUQy5sAJ8Ag4Ax6UYyZxLOTy2gAr4BXwG/B3OfbfRJVuOkSSvgKeAk+QrHtoCY6NBniNJP0AfAf8CFyklLZ9XdXXURO03B4hSc+BZ0jUEeMVtUaiPi7H1uV1hZblXvaKKt10gDrnDHXSM+Ax+gGHjGvZGRntSR+Vr/8CfgH+AN6klO7c3Ic6aob2pDNgiSQdI4ljZVbel7R77oyBFdInyrpqju52C9RJY73jGQeoDqvJdRcf2mdqen7q8t51DYkKCiHKSYhyEqKchCgnIcpJiHISopyEKCchykmIchKinIQoJyHKSYhyEqKchCgnIcpJiHISopyEKCchykmIchKinIQoJyHKSYhyEqKc3BLVyW1+iKS7ks/XsZ9O8tfSHYNRmIqweqdATik17CSGp3AtaYoCVRY7nNAGrGoVZs0xQwG5BW18cZtSujJZ1lETFKh6CHyKglZvkbQ5dcoySXPgFNVqdf8O/EmbR2e6k9f8AvgWJYH/QbHiU2S8RlEzVN/XSNh9FKf+nrarmpxz7nbUEeqmJ8CXKLB+gVryhPEGXPexGw1/iIQtgHPUTT/TudmZKNujjlFc+hvUZZfl3JLxRqb3YY2xREsro6SwfarhGPm4boxu2NWW4AIZfoCy1035xnvUcSfsbjVLVNsEuVih+m/VuZsK7m5wJ+V8pk3S1tRRFg2/j+q+QvvS3hvXvvi0yTpEwuxYTQ+i1lUT2s/AbOi5uw/lzGt8LDC6v/jMQJ21LKX/nRDlJEQ5CVFOQpSTEOUkRDkJUU5ClJMQ5SREOQlRTkKUkxDlJEQ5CVFOQpSTEOUkRDkJUU5ClJMQ5SREOQlRTkKUk66oG4M8GRi3WCG99ZsoG+S5RX+D39LGYT4EBuu37EFTTl6iENUKJTvm7OSEKiTTJllWqP5L5KOxi6Y5Z0vBrtGYxXOUNvsESbIprrVi014tZXeOPKzpJIO7HbUpF7wAPkdBqzXjneLqxaa9/oSymy+Qhw3djirvGbXaCniJUmhb4DPapF2tvEOifkUjcV8iD1t296jO8nuNJp02aODwKeMcoOylO2j5Ao3GfYU83Ajk3xjTnVKypF0NI7m97B3dnXO+XnbA7XnmlQ1593LjGWrfvOA7B7/X9G8DvPSN6Xb9K4EA/gV6vQiQwajILwAAAABJRU5ErkJggg=="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image1_2088_9096",
				width: 69,
				height: 80,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABQCAYAAABPlrgBAAAACXBIWXMAAC4jAAAuIwF4pT92AAACIklEQVR4Xu3cMW4TQRiG4fdHkWjWadLb1EBPFS5AlRrlDhyIjgPQUHIKJFJQYW4A2To/xcxGXvNNllDh2e+RVrK0K0vzasdy8WsiM7G5s6UHACJiA+yAYenZ/9wI7IExH3gbYulNqUFeA9eUMKdsD3wEvgLfM3OUT2Vm8wI2wBvgE/ATuDvx6xfwBXgPvKS+FMdXc/tERFDejGvgEjhvPXtCNsALyjZq/hQ8ad2oBmBL+bJeBGU9zd/IpShQvqQn0w64AnZ1R8z8TZQeTTvgn9+UXjV3wJqjNDmK4CiCowiOIjiK4CiCowiOIjiK4CiCowiOIjiK4CiCowiOIjiK4CiCowiOIjiK4CiCowiOIjiK4CiCowiOIsyiqFmNtThc+32UiBiAbR38W5W65m1tUKIcz7dFxDn9TTApQZnlu6ROf0ZEHA4CTqOhr+rnG/qadTs2UIYCd8Bb4CnwGf4cLt5QojyjRPlGn2GCssZ3QFJGvW6mm2pkdBqr3FECXdDnVhqA5+pGa452Gqsc6DPIZFrbbOx86X9Kz0GalqKskqMIjiI4iuAogqMIjiI4iuAogqMIjiI4iuAogqMIjiI4iuAogqMIjiI4iuAogqMIjiI4iuAogqMIjiI4iuAownGUNZ+ZeL/2w/mUEfhBGdjpcXrpIbeUtY9Qo2RmRsQe+FAfOvXjEB9rWvs+M3N2dmRHB2c+1kgJcgviQM21Dhgfnjr6G8DJn1jSL0gcAAAAAElFTkSuQmCC"
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image2_2088_9096",
				width: 69,
				height: 43,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAArCAYAAAAuc0UDAAAACXBIWXMAAC4jAAAuIwF4pT92AAACDElEQVRoQ+2ZPXLCMBBG32YykwY4Ak7PAVKRO6RPTpcD5ALpcgbSkyvgXimkxcJZY35s2TF6M8zAIBf7vN/aI4lzjswhd/EPEZGmhVMnrn0vRURmwFJE5uZVEybUvAwOvJRgqQDegLWILG6ha8SzANb42gsRkftozRx4Bp7C942IbIHSTXDwhO4ogBXwCjwAnwCxFPAynoBHYAN8EOQ453ZMgJCAOVV3rIAl8K1r6lIIF6yoLG6AdxH5Anb/tWuCjBlVXW94MX9mqCUFQG2qxVn4/MtI1aLyQnXTVchBLU1SFAEW+FlTUIsUI5fTEJUCf4MbHyRtUhQrUqOWU+uOOCqtT9VTpcBhpEw5YxjGR7rj5Pevc6QoTXIGHcYtg7S1O2IukaKMZhifMEjP4hopymDD+NJB2kYXUpRk86bLqFh0KQUSzJuuo2LRtRSl83nTV1Qs+pKiXD1v+o6KRd9SlIte/lJExSKVFDjh5Q8oo/VJomKRUopyTM42WleQICoWQ0hRLDlxp+gc6TUqFkNKUWI51n/JGYMUZRABFgdHHBlPlmKQpRhkKQZZikGWYpClGGQpBlmKQZZikKUYZCkGWYpBlmJQl3LWDvvE2Nce76eUwA9+syf5btfA7PC1lxCkOOdc2Dh+D4sK+9rJorVvnXNO4pOF6Ehh1nDxVCnxQnYAUj9uCYdPN0d87vQLtdq6w2QabggAAAAASUVORK5CYII="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image3_2088_9096",
				width: 60,
				height: 60,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVRoQ+2b61LbMBBGj3IhoUAphbbT93+6Ti8DoZCEXNwfq43WshyHUizi+pvZ8SWO2ONd2WH82RVFwf+kUdMBKTnnXNMxr63iLyvl9n3PgFnA7LBGhV0echJqgT2sAwZ+add3hyW++tqykBpbu70PPAnsnBsgcANgGIU9AbmANTaJ2ALbOujKHDawI2AMnJgY+dBjoF1ohdgicGtgBTyZWAE455LQJWDfxgo7AabAO+AMOPX7TqhWui3ZFl4jgHPg0YTz+5PQO+Bozo4RwAvg0sd7BH7qPx/S3ny2SWt1Vwjsb2AG3CI56fE2dopbWqt7gsBdAp+AG+Cj3z6lXOU2pQBrYAk8AHfATwJLaT4755ytsgXWCg+R1j0DPiDAX4HPwBVwTpjPOVpa23kJ3AO/kHwx+5dIW6/jAVIVHiJAp0gbXwNfEOhrpM0nhJbOAbwBFkgrT/1nWvF7v9QO1FsWUAXWCo+Rgc4Q6CukrW/ID6wtvSBUdoG09jlSqNQ1BvDA5oKlFy2tsl6lz31c8DaAN0h+IJW9INxJdLol80v9lrbQ9l48iSI3MMg8nRJyGpOAtReuVEvr0oLbGJn1NmFVOh9tLiOzrj+KkrnVVTgVdiAbOVSXlwVN5nfofTT+Yi5QVV1RiNYragLODfbP1QR8bGosUNeAG9UDd109cNfVA3ddPXDX1QN3XT1w19UDd109cNfVA3ddPXDX1QMfuWrdO6om4MYBjk1NwKoYPPeJiD0c1stR8XVY1VkP4wHsvvgPtK04hy3hKb992p/MMQauGyxlAIP2nyBqXprD2ix13Z6AilIVtoOq8UvNX0vCk/ccz4dtbgsTamRZEcB3Fa64eIqiKLyPVKuqsEs/4IMPNZA8kRdYPR4zH2pkmRPcOyVola2wbeMVAvvoB7tF/BMgf0h9WjmAYxfPD8S6dIeY1OZI/gpcUmoOq8tNYa0Pao6YR9QlA+1CK3Ds0/qGmNNmSN5PhPm8t8J69rS6d5TdMrcE66G1F7Ql29KxE+87kp8FPqjCatp8RAbAb88QC9OE4KhVvTa4TXyf1zKucMU7vQP2F664pUFOgFZbYXNYlqB8nalz0y6Q/JO3ppJB3BjU1I1nPVq6bWFzAEOzX3pDjUm84oiPbMSxL2tAmLttw6oKE6kfRHsd8XWvAMR2oEG0jVm2rcIsbYvvtp/9zsPuw+pbLbkg62ThX/ZWS53ewjtLcBhcSs8GPnYd+v9wZ/QHTbqvfA0XAmsAAAAASUVORK5CYII="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image4_2088_9096",
				width: 46,
				height: 46,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVRoQ+3ZsQkCMRyF8S8iZAm765zAzr0cwJ3sLG8BN8gQSfW3CIdeZ/VM4P0gTSDwcXDVSxFBSikDJyAzpgaUiGjbRaLHXoAbPX5EBbgD63f8AjyACsSgpwJP4ArkiADgDLx+ePzvU+kfeIkIDsxj9x/OFL7jcDWHqzlczeFqDldzuJrD1Ryu5nA1h6s5XM3hag5Xc7iaw9UcruZwNYcLNPre2aCH7y4G1YCVPtIWgCOf1RYmWpbTtFv+Ni/P5g1xTodLg4W2uAAAAABJRU5ErkJggg=="
			})
		] })
	]
});
export default SvgMicrosoftOutlook;
